import { render, staticRenderFns } from "./ColoredAmount.vue?vue&type=template&id=3d87042c&"
import script from "./ColoredAmount.vue?vue&type=script&lang=ts&"
export * from "./ColoredAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports